var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.13,
    height: 8.101,
    viewBox: "0 0 8.13 8.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(-51.656 -52.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18376",
    "data-name": "Path 18376",
    d: "M193.008,139.825a1.746,1.746,0,0,1-.174.245c-.633.631-1.273,1.255-1.9,1.887a.341.341,0,1,1-.47-.48c.448-.431.887-.872,1.33-1.308a.287.287,0,0,1,.076-.039l-.027-.036h-3.814a.336.336,0,0,1-.37-.268.33.33,0,0,1,.3-.394c.036,0,.073,0,.11,0h3.8c-.032-.034-.051-.056-.072-.076q-.669-.661-1.339-1.321a.35.35,0,0,1-.123-.343.33.33,0,0,1,.525-.19.812.812,0,0,1,.076.068q.971.958,1.94,1.918a1.456,1.456,0,0,1,.143.2Z",
    transform: "translate(-133.272 -83.25)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18377",
    "data-name": "Path 18377",
    d: "M51.707,56.509q0-1.489,0-2.979a.993.993,0,0,1,.776-.992,1.052,1.052,0,0,1,.24-.026q1.478,0,2.955,0a.332.332,0,0,1,.344.437.322.322,0,0,1-.283.224c-.036,0-.073,0-.11,0H52.761a.339.339,0,0,0-.369.239.554.554,0,0,0-.016.147q0,2.947,0,5.895a.343.343,0,0,0,.391.389h2.893a.339.339,0,0,1,.369.239.331.331,0,0,1-.3.424h-.008c-1.03,0-2.059.007-3.088,0a.979.979,0,0,1-.923-.955c-.008-.342,0-.685,0-1.027Q51.707,57.517,51.707,56.509Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.889913dd1c0dc4463e02fbab1ce3b6d7.svg";
export { ForwardRef as ReactComponent };